(() => {
  const PREV_SVG =
    '<svg class="aa-arogya__icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.5 4.5L8 12l7.5 7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const NEXT_SVG =
    '<svg class="aa-arogya__icon" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.5 4.5L16 12l-7.5 7.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CTA_SVG =
    '<svg class="aa-arogya__cta-icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const looksBroken = (el) => {
    if (!el) return false;
    if (el.querySelector('svg')) return false;
    const text = (el.textContent || '').trim();
    if (!text) return true;
    // Mojibake / odd leftovers from corrupted unicode arrows
    return /[ΓГâ]|Ç|å|Æ|╣|║|†|�/.test(text) || text.length <= 3;
  };

  const fixIcons = (root) => {
    const prev = root.querySelector('[data-aa-prev]');
    const next = root.querySelector('[data-aa-next]');
    if (looksBroken(prev)) prev.innerHTML = PREV_SVG;
    if (looksBroken(next)) next.innerHTML = NEXT_SVG;

    root.querySelectorAll('.aa-arogya__cta a').forEach((link) => {
      if (link.querySelector('.aa-arogya__cta-icon')) return;
      const label =
        (link.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .replace(/\s*(ΓåÆ|→|â†’|➜|⟶)$/, '')
          .trim() || 'Explore Our Functional Products';
      link.innerHTML = `<span class="aa-arogya__cta-text">${label}</span> ${CTA_SVG}`;
    });
  };

  const initCarousel = (root) => {
    if (root.dataset.aaReady === 'true') return;
    root.dataset.aaReady = 'true';

    fixIcons(root);

    const track = root.querySelector('[data-aa-track]');
    const prev = root.querySelector('[data-aa-prev]');
    const next = root.querySelector('[data-aa-next]');
    if (!track) return;

    const scrollByCard = (dir) => {
      const card = track.querySelector('.aa-arogya__card');
      const amount = card ? card.getBoundingClientRect().width + 16 : 220;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    prev?.addEventListener('click', () => scrollByCard(-1));
    next?.addEventListener('click', () => scrollByCard(1));

    const syncNav = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };

    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();

    root.querySelectorAll('[data-aa-add]').forEach((btn) => {
      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        const id = Number(btn.getAttribute('data-variant-id'));
        if (!id) return;

        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        try {
          const res = await fetch(
            window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
            }
          );

          if (!res.ok) throw new Error('Add failed');

          btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer?.open) {
            cartDrawer.open();
          } else {
            const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart, cart-icon-bubble');
            cartIcon?.click?.();
          }

          setTimeout(() => {
            btn.textContent = original;
            btn.disabled = false;
          }, 1200);
        } catch (err) {
          window.location.href = `/cart/add?id=${id}&quantity=1`;
        }
      });
    });
  };

  const cartRoot = () =>
    window.Shopify?.routes?.root ? window.Shopify.routes.root : '/';

  const addToCart = async (variantId, quantity) => {
    const res = await fetch(`${cartRoot()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  };

  const openCart = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.open) {
      cartDrawer.open();
      return;
    }
    document.querySelector('#cart-icon-bubble, .header__icon--cart, cart-icon-bubble')?.click?.();
  };

  const formatVariantPrice = (cents) => {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return `₹ ${Math.round(amount)}`;
  };

  const productHandleFromBuyBlock = (root) => {
    const attr = root.getAttribute('data-product-handle');
    if (attr) return attr;
    const href = root.querySelector('.aj-buy__details')?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const variantLabel = (variant, optionName) => {
    if (variant.public_title && variant.public_title !== 'Default Title') return variant.public_title;
    if (variant.option1 && variant.option1 !== 'Default Title') return variant.option1;
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    return optionName || 'Option';
  };

  const renderBuyVariants = (root, product, currentId, setVariantId) => {
    const variants = (product.variants || []).filter((variant) => variant.title !== 'Default Title' || (product.variants || []).length > 1);
    if (!variants.length || (product.variants || []).length <= 1) return;

    if (root.querySelector('[data-aj-variants]')) return;

    const optionName = (product.options && product.options[0]) || 'Size';
    const wrap = document.createElement('div');
    wrap.className = 'aj-buy__variants';
    wrap.setAttribute('data-aj-variants', '');
    wrap.innerHTML = `
      <p class="aj-buy__variant-label">${optionName}</p>
      <div class="aj-buy__variant-list" role="list">
        ${variants
          .map((variant) => {
            const selected = Number(variant.id) === Number(currentId) ? ' is-selected' : '';
            return `<button type="button" class="aj-buy__variant${selected}" data-aj-variant="${variant.id}" ${
              variant.available === false ? 'disabled' : ''
            }>${variantLabel(variant, optionName)}</button>`;
          })
          .join('')}
      </div>
    `;

    const qty = root.querySelector('.aj-buy__qty');
    qty?.parentNode?.insertBefore(wrap, qty);

    wrap.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-aj-variant]');
      if (!btn || btn.disabled) return;
      const id = Number(btn.getAttribute('data-aj-variant'));
      const variant = variants.find((item) => Number(item.id) === id);
      if (!variant) return;
      wrap.querySelectorAll('[data-aj-variant]').forEach((el) => {
        el.classList.toggle('is-selected', el === btn);
      });
      setVariantId(id);
      const priceEl = root.querySelector('.aj-buy__price');
      const formatted = formatVariantPrice(variant.price);
      if (priceEl && formatted) priceEl.textContent = formatted;
    });
  };

  const initBuyBlock = (root) => {
    if (root.dataset.ajReady === 'true') return;
    root.dataset.ajReady = 'true';

    let variantId = Number(root.getAttribute('data-variant-id'));
    const qtyInput = root.querySelector('[data-aj-qty]');
    const minus = root.querySelector('[data-aj-qty-minus]');
    const plus = root.querySelector('[data-aj-qty-plus]');
    const addBtn = root.querySelector('[data-aj-add]');
    const buyBtn = root.querySelector('[data-aj-buynow]');

    const readVariantId = () => Number(root.getAttribute('data-variant-id')) || variantId;

    const setVariantId = (id) => {
      variantId = Number(id);
      root.setAttribute('data-variant-id', String(variantId));
    };

    const readQty = () => {
      const n = Number(qtyInput?.value || 1);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
    };

    const setQty = (n) => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, Math.floor(n) || 1));
    };

    minus?.addEventListener('click', () => setQty(readQty() - 1));
    plus?.addEventListener('click', () => setQty(readQty() + 1));
    qtyInput?.addEventListener('change', () => setQty(readQty()));

    const handle = productHandleFromBuyBlock(root);
    if (handle) {
      fetch(`${cartRoot()}products/${handle}.js`)
        .then((res) => (res.ok ? res.json() : Promise.reject()))
        .then((product) => renderBuyVariants(root, product, readVariantId(), setVariantId))
        .catch(() => {});
    }

    addBtn?.addEventListener('click', async (event) => {
      event.preventDefault();
      const id = readVariantId();
      if (!id) return;
      const original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      try {
        await addToCart(id, readQty());
        addBtn.textContent = 'Added';
        openCart();
        setTimeout(() => {
          addBtn.textContent = original;
          addBtn.disabled = false;
        }, 1200);
      } catch (err) {
        window.location.href = `${cartRoot()}cart/add?id=${id}&quantity=${readQty()}`;
      }
    });

    buyBtn?.addEventListener('click', async (event) => {
      event.preventDefault();
      const id = readVariantId();
      if (!id) return;
      const original = buyBtn.textContent;
      buyBtn.disabled = true;
      buyBtn.textContent = 'Redirecting…';
      try {
        await addToCart(id, readQty());
        window.location.href = `${cartRoot()}checkout`;
      } catch (err) {
        window.location.href = `${cartRoot()}cart/${id}:${readQty()}`;
      } finally {
        setTimeout(() => {
          buyBtn.textContent = original;
          buyBtn.disabled = false;
        }, 1500);
      }
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-aa-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-aj-buy]').forEach(initBuyBlock);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
